module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parent",
    class: ['d-flex', 'align-items-center', _vm.computedClass]
  }, [_c('div', {
    staticClass: "meter bg-light"
  }, [_c('span', {
    class: ['d-flex', _vm.percentageBg],
    style: ({
      width: _vm.availabilityPercentage + '%'
    })
  })]), _vm._v(" "), (_vm.showText) ? _c('strong', {
    class: ['text-right', 'flex-all', _vm.percentageColor]
  }, [_vm._v(_vm._s(_vm.availability))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5c84940c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c84940c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/EventMeter.vue
// module id = 2712
// module chunks = 0